import {getCoreRowModel, getExpandedRowModel, getSortedRowModel, useReactTable} from '@tanstack/react-table';
import React, {useEffect, useMemo, useState} from "react";
import BTable from "react-bootstrap/Table";
import {TableHead} from "./TableHead";
import {TableLoading} from "./TableLoading";
import {TableBody} from "./TableBody";
import Notify from "../../../../Common/Notify/Notify";
import {TableFooter} from "./TableFooter";
import {TableFilter} from "./TableFilter";
import {useSearchParams} from "react-router-dom";
import {getTableDataV2} from "./TableDataV2/TableDataServiceV2";

const DEFAULT_SORT = [{id: 'createdAt', desc: true}];
const DEFAULT_DATA = {content: [], pageCount: 0, isLoading: true};

const mapQueryStringFilter = (searchParams) => {
    return [...searchParams.keys()].map(x => ({id: x, value: searchParams.get(x)}));
}
export const ReactTableV2 = ({tableSchema}) => {

    const [tableData, setTableData] = useState(DEFAULT_DATA);
    const [schema, setSchema] = useState({columns: [], renderRowSubComponent: null});
    console.log('schema', schema)

    const [{pageIndex, pageSize}, setPagination] = useState({
        pageIndex: 0,
        pageSize: 10,
    })

    let [searchParams] = useSearchParams();

    const [globalFilter, setGlobalFilter] = useState('')
    const [columnFilters, setColumnFilters] = useState(mapQueryStringFilter(searchParams))
    const [columnOrder, setColumnOrder] = useState([]);
    const [sorting, setSorting] = useState([])

    const pagination = useMemo(() => ({
            pageIndex,
            pageSize,
        }),
        [pageIndex, pageSize]
    );

    useEffect(() => {
        console.log('aaa');
        const tableSortBy = sorting.length === 0 ? schema.defaultSortBy : sorting;

        if (schema.getCustomData) {
            const customData = schema.getCustomData({
                pageIndex, pageSize,
                sortBy: tableSortBy,
                filters: columnFilters
            });
            setTableData(customData)
            return;
        }

        if (schema.baseEndpoint) {
            setTableData(DEFAULT_DATA);
            getTableDataV2({
                columns: schema.columns,
                pageIndex, pageSize,
                sortBy: tableSortBy,
                filters: columnFilters,
                baseEndpoint: schema.baseEndpoint,
                customizeResponseData: schema.customizeResponseData
            }).then(
                x => setTableData(x),
                err => Notify.error("Falha ao carregar dados", err));
        }

    }, [pageIndex, pageSize,
        columnOrder,
        columnFilters,
        schema,
        globalFilter,
        sorting
    ])

    useEffect(() => {
        const baseEndpoint = tableSchema.getEndpoint ? tableSchema.getEndpoint() : null;
        const getCustomData = tableSchema.getCustomData;
        const columns = tableSchema.getColumns();
        const defaultSortBy = tableSchema.defaultSortBy ? tableSchema.defaultSortBy() : DEFAULT_SORT;
        const renderRowSubComponent = tableSchema.renderRowSubComponent;
        const getRowCanExpand = () => renderRowSubComponent;
        const customizeResponseData = tableSchema.customizeResponseData;
        setTableData(DEFAULT_DATA);
        setSchema({
            columns,
            baseEndpoint,
            renderRowSubComponent,
            defaultSortBy,
            getRowCanExpand,
            getCustomData,
            customizeResponseData
        });
    }, [tableSchema])

    const tableInstance = useReactTable({
        columns: schema.columns,
        data: tableData.content,
        state: {
            pagination,
            columnFilters,
            globalFilter,
            columnOrder,
            sorting

        },
        getRowCanExpand: schema.getRowCanExpand,
        onSortingChange: setSorting,
        getCoreRowModel: getCoreRowModel(),
        onGlobalFilterChange: setGlobalFilter,
        onColumnFiltersChange: setColumnFilters,
        onPaginationChange: setPagination,
        onColumnOrderChange: setColumnOrder,
        getSortedRowModel: getSortedRowModel(), //order doesn't matter anymore!
        getExpandedRowModel: getExpandedRowModel(),
        manualPagination: true,
        manualSorting: true

        // debugTable: true,
        // debugHeaders: true,
        // debugColumns: true,
    });

    const headerGroups = tableInstance.getHeaderGroups()

    return (
        <>
            <TableFilter headerGroups={headerGroups}/>
            <BTable responsive striped bordered hover size="sm"
                    className={"cflow-table " + (tableSchema.tableClass ?? '')}>
                <TableHead headerGroups={headerGroups} getRowCanExpand={schema.getRowCanExpand}/>
                <TableLoading isLoading={tableData.isLoading}>
                    <TableBody table={tableInstance} renderRowSubComponent={schema.renderRowSubComponent}/>
                    <TableFooter totalElements={tableData.totalElements} table={tableInstance}/>
                </TableLoading>
            </BTable>
        </>
    )
}

